
enum OrganisationType {
    OPERATOR = 'operator',
    ANPP = 'anpp',
    BACK_OFFICE = 'back-office',
    AVIATION_AUTHORITY = 'aviation-authority',
}

export default OrganisationType;
